import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, Select, MenuItem, Tooltip, Zoom } from '@material-ui/core';
import { Button, Container, Typography, List, ListItem, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Modal } from '@material-ui/core';
import { connect, ConnectedProps } from 'react-redux';
import store from './../redux/store';
//import { usuario } from '../redux/usuarios/actions';
import { fetchEmpresas } from '../redux/empresas/actions';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import { InputAdornment } from '@material-ui/core';
import { Email, Phone, Business, Link, FileCopy } from '@material-ui/icons';
import { getEmpresas } from '../api';
import { green } from '@material-ui/core/colors';
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CardMedia from '@mui/material/CardMedia';
import { UploadFile } from '@mui/icons-material';
import {
    useGridApiRef,
    GridRowsProp,
    GridRowModesModel,
    GridRowModes,
    DataGrid,
    GridColDef,
    GridToolbar,
    GridToolbarContainer,
    GridActionsCellItem,
    GridEventListener,
    GridRowId,
    GridRowModel,
    GridRowEditStopReasons,
    GridValueGetterParams,
    GridToolbarExport,
} from '@mui/x-data-grid';
import { Autocomplete, Avatar, CardActions, CardHeader, Collapse, Divider, LinearProgress, ListItemButton, ListSubheader, Stack, styled } from '@mui/material';

import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { DefaultizedPieValueType } from '@mui/x-charts';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';


import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { client, AUTH_USER, AI_RESUME_FEEDBACK, getUsers, filterCompany, whoami, UPDATE_USER, REMOVE_COMPANY, CREATE_COMPANY, getCompanies, UPDATE_COMPANY, getCategories, filterChatgpt, findProfileByUser, filterCredit, SET_DEFAULT_RESUME } from '../graphqlClient/graphql'

import { useMutation } from '@apollo/client';
import { serverConfig } from '../api/apiConfig';
import Notifications from './../components/notifications/Notifications';
import { width } from '@mui/system';
import { setUser } from './../redux/user/actions';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '100%',
        textAlign: 'center',
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        //alignItems: 'center',
        height: '100%',
    },
    content: {
        textAlign: 'center',
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    listContainer: {
        //maxWidth:'80%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        justifyContent: 'center',
        alignItems: 'flex-start',

        maxHeight: 'calc(100vh - 100px)',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'green',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'darkgreen',
        },
    },
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
    },
    deleteButton: {
        marginLeft: theme.spacing(1),
    },
    addButton: {
        margin: theme.spacing(2),
        backgroundColor: green[500],
        color: 'white',
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    modalContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
}));

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

type PropsFromRedux = ConnectedProps<typeof connector>;

const AiResumeFeedback: React.FC<PropsFromRedux> = ({ isLoadingUsuarios,setUser, isLoadingUsuariosByFilter, isLoadingCreateUsuario, empresas }) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const messages: any = []
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
    const [selectedUsuario, setSelectedUsuario] = React.useState('');

    const [loading, setLoading] = React.useState(false);


    const [categories, setCategories] = React.useState<any>([]);
    const [companies, setCompanies] = React.useState<any>([]);
    const [chatgpt, setChatgpt] = React.useState<any>([]);
    const [selectedCategory, setSelectedCategory] = React.useState<any>({});
    const [selectedCompany, setSelectedCompany] = React.useState<any>({});
    const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
    const [save, setSave] = React.useState(false);
    const [selectedUser, setSelectedUser] = React.useState<any>({ key: 0, value: 'Filtro por operador' });
    const [usuario, setUsuario] = React.useState<any>({});
    const [messageData, setMessageData] = React.useState<any>('');
    const [job, setJob] = React.useState<any>('');
    //const [result, setResult] = React.useState<any>('### Análise do Currículo para a Vaga de Senior Civil Engineer: #### Pontos Positivos: - **Experiência Diversificada:** A candidata possui experiência em diversos projetos de engenharia civil em diferentes países como Irlanda, Noruega, Reino Unido, Estados Unidos e Bolívia, abrangendo áreas como infraestrutura, telecomunicações, e supervisão de obras civis. - **Habilidades Técnicas Avançadas:** Demonstrou habilidades avançadas em modelagem 3D, detalhamento de reforço estrutural, coordenação de modelos de construção, análise estrutural, gerenciamento de projetos, entre outras. - **Fluência em Vários Idiomas:** A candidata é fluente em espanhol, português e inglês, o que pode facilitar a comunicação em ambientes multiculturais e internacionais. #### Pontos a serem Melhorados: - **Formação Acadêmica Limitada:** Embora tenha formação em Engenharia Civil, seria interessante ver mais especializações ou cursos específicos na área de engenharia civil ou gerenciamento de projetos. - **Contextualização das Experiências:** Seria útil fornecer mais detalhes sobre o contexto e escala dos projetos nos quais a candidata trabalhou para fornecer uma visão mais completa de sua experiência. #### Nota da Avaliação: 8/10 Com base na análise do currículo da Stephanie Nuñez Nogales, ela apresenta uma sólida experiência em engenharia civil, habilidades técnicas avançadas e fluência em vários idiomas, o que é um grande diferencial para a vaga de Senior Civil Engineer. No entanto, a falta de detalhes adicionais sobre os projetos e uma formação acadêmica mais expansiva são áreas que poderiam ser melhoradas para enriquecer ainda mais seu perfil profissional.');
    const [result, setResult] = React.useState<any>('');
    const [finalResult, setFinalResult] = React.useState<any>('');
    const [activeResultId, setActiveResultId] = React.useState<string>('');
    const [startDate, setStartDate] = React.useState<any>(null);
    const [endDate, setEndDate] = React.useState<any>(null);
    const [expanded, setExpanded] = React.useState('');
    const [link, setLink] = React.useState('');
    const [file, setFile] = React.useState<any>();
    const [image, setImage] = React.useState<any>('');
    const [newPdf, setNewPdf] = React.useState<any>('');
    const [totalCredits, setTotalCredits] = React.useState<any>(0);
    const [usedCredits, setUsedCredits] = React.useState<any>(0);
    const [cvConsent, setCvConsent] = React.useState<boolean>(false);
    const [noticeVisible, setNoticeVisible] = React.useState<boolean>(true);

    const handleExpandClick = (item: any) => {
        const newValue = expanded == item.id ? '' : item.id
        setResult(item.response)
        setActiveResultId(item._id)
        setNewPdf(false)
        //setExpanded(newValue);
    };

    const checkCredit = async (u:any) => {
            setLoading(true)
            //const u: any = await getUser();
    
            if (!u._id) {
                const notData = {
                    type: 'error',
                    message: "Undefined User",
                    title: 'wescout',
                    timeOut: 2500,
                    callback: () => { },
                    priority: true,
                }
                Notifications(notData)
                return
            }
    
            const objToSend = {
                //startDate,
                //endDate,
                //empresa:empresa
                //category:selectedCategory?._id || '',
                "active": true,
                "user": u._id,
            }
            //setIsLoadingCompaniesByFilter(true)
            console.log('objToSend', objToSend)
    
            const result = await filterCredit(objToSend)
            console.log('filterCredit result ==>>', result)
            if (result.length == 0) {
                console.log('call add credit')
                //await handleAddCredit(u);
            } else {
                const res = result[0]
                const total = res.amountPdf
                const used = res.chatgpt.length
                setTotalCredits(total)
                setUsedCredits(used)
                console.log('checkCredit', result)
                
            }
            setLoading(false)
            return;
        }

    const [AiResumeFeedback, { data }] = useMutation(AI_RESUME_FEEDBACK);
    const [SetDefaultResume] = useMutation(SET_DEFAULT_RESUME);

    const getProfileByUserAsync = async (userId: any) => {

        try {
          const profile: any = await findProfileByUser(userId);
          console.log('profile ==>>', profile)
          if (!profile) {
            return false;
            //setHasProfile(false)
          } else {
            return profile;
            //setHasProfile(true)
    
          }
    
    
        }
        catch (error) {
          console.log("Erro no getUser >>>>>", error)
        }
    
      }

    const getCategoriesAsync = async () => {

        const result: any = await getCategories()
        console.log('resutl ===>', result)

        if (result?.length) {
            setCategories(result)
        }
    }
    const getChatgptAsync = async (userResume: any) => {

        const result: any = await filterChatgpt({ user: userResume._id, type: "airesumefeedback" })
        //console.log('resutl ===>', result)

        if (Array.isArray(result) && result.length) {
            setChatgpt(result)
            // Se o usuário possui resultados mas nenhum estiver marcado como default, define o primeiro como default automaticamente
            const hasDefault = result.some((item: any) => item.isDefault === true);
            if (!hasDefault && result.length > 0) {
                console.log('No default resume found, setting first result as default:', result[0]._id);
                handleSetDefault(result[0]._id);
            }
        } else if (!Array.isArray(result)) {
            // Safety net: filterChatgpt returned non-array (error case)
            setChatgpt([])
        }
    }

    const getCompaniesAsync = async () => {

        const result: any = await getCompanies()
        console.log('resutl ===>', result)

        if (result?.length) {
            setCompanies(result)
        }
    }

    const getUser = async () => {
        try {
            const user: any = await whoami();
            console.log('user ==>>', user)
            getChatgptAsync(user)
            setUsuario(user);
            checkCredit(user)
        }
        catch (error) {
            console.log("Erro no getUser >>>>>", error)
        }
    }

    const handleSetDefault = async (chatgptId: string) => {
        setLoading(true);
        try {
            await SetDefaultResume({
                variables: {
                    id: chatgptId,
                    userId: usuario._id
                },
                onCompleted: async () => {
                    const notData = {
                        type: 'success',
                        message: 'Default resume set successfully!',
                        title: 'wescout',
                        timeOut: 2000,
                        callback: () => { },
                        priority: true,
                    }
                    Notifications(notData)
                    getChatgptAsync(usuario)
                    setLoading(false)
                    // Update current user
                    const user: any = await whoami()
                    if (user && user._id) {
                        const newUser: any = { ...user }
                        const profile = await getProfileByUserAsync(user._id)
                        if (profile && profile.pdf) {
                            newUser.pdf = profile.pdf
                        }
                        setUser(newUser)
                    }
                }
            });
        } catch (error: any) {
            console.error('Error setting default resume:', error);
            const notData = {
                type: 'error',
                message: "Error setting default resume",
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            setLoading(false);
        }
    }

    useEffect(() => {

        getUser();

        //getCategoriesAsync();
        //getCompaniesAsync();

    }, []);

    function formatText(inputText: string): string {
        // Substitui quebras de linha por <br>
        const formattedText0 = inputText.replace(/Nota da Avaliação: (\d\/10)/, '<strong>Nota da Avaliação: $1</strong> <br>');
        const formattedText = formattedText0.replace('###', '');
        const formattedText1 = formattedText.replace(': -', ':');
        const formattedText2 = formattedText1.replace('. -', ':');

        // Aplica negrito para o texto entre ** **
        const boldText = formattedText2.replace(/\*\*(.*?)\*\*/g, '<br><strong>$1</strong>');

        return boldText;
    }

    const makeBullets = (val: any) => {
        let resp = ''
        if (val.length) {
            for (let z = 0; z < val.length; z++) {
                const valor = val[z]
                if(typeof valor != "string"){
                    resp +=  makeBullets(valor)+"<br>"
                }else{
                    resp += `* ${valor} <br>`
                }
                
            }
        } else {
            for (var i in val) {
                const valor = val[i]
                if(typeof valor != "string"){
                    resp += "<h3>"+ i+"</h3><br>"+ makeBullets(valor)
                }else{
                    resp += `* ${i}: ${valor} <br>`
                }
                
            }
        }


        return resp;
    }

    const makeFinalResult = (res: any) => {
        let resObj
        let final = ''
        if (res) {
        try {
            resObj = JSON.parse(res)
        } catch (e) {
            console.error('Error parsing AI response:', e);
            setFinalResult(`<p style="color: red;">Error: Could not parse AI response. Raw response: ${res}</p>`);
            return;
        }
            console.log('resObj', resObj)
            if (resObj) {
                for (var i in resObj) {
                    const valor: any = resObj[i]
                    final += '<h2>' + i + "</h2><br>"
                    console.log('typeof valor', typeof valor)
                    if (typeof valor == 'object') {
                        final += makeBullets(valor)

                    } else {
                        final += valor
                    }

                }
            }
            console.log('final', final)
            setFinalResult(final)
            
            return final
        }

    }


    useEffect(() => {
        let resultObj
        let final = ''
        if (result) {
            makeFinalResult(result)
        } else {
            setFinalResult('')
        }
        /*  if(result.length){
             let res = "";
             const parts = result.split("####").map((item:any)=>{
                 res += `<p>${formatText(item)}</p>`
 
             })
 
         
         setFinalResult(res)
         }else{
             setFinalResult('')
         } */
    }, [result]);

    useEffect(() => {
        if (isLoadingUsuarios) {
            setLoading(true)
        }
        if (loading && !isLoadingUsuarios) {

            setLoading(false)
        }
        console.log('isLoadingUsuarios ==> ', isLoadingUsuarios)

    }, [isLoadingUsuarios]);

    useEffect(() => {
        if (isLoadingCreateUsuario) {
            setLoading(true)
        }
        if (loading && !isLoadingCreateUsuario) {

            setLoading(false)
        }
        console.log('isLoadingCreateUsuario ==> ', isLoadingCreateUsuario)

    }, [isLoadingCreateUsuario]);

    const handleDeleteClick = (UsuarioId: any) => {
        console.log('UsuarioId', UsuarioId)
        setSelectedUsuario(UsuarioId);
        setDeleteConfirmationOpen(true);
    };

    const handleDeleteConfirmation = () => {
        console.log('selectedUsuario', selectedUsuario)
        //deleteUsuario(selectedUsuario);
        setDeleteConfirmationOpen(false);
    };

    //init DataGrid dependencies

    const clearData = (d: any) => {
        const dateTransform = (moment(d).format('DD-MM-YYYY h:m'));
        return dateTransform
    }

    const handleFileChangePdf = (event: any) => {
        const file = event.target.files[0];
        const fileSize = file.size / 1024 / 1024; // in MB
        const fileType = file.type;

        if (fileType !== 'application/pdf') {
            alert('Please, select a PDF file.');
            event.target.value = null; // limpa o valor do input
        } else if (fileSize > 10) {
            alert('The selected file is too large. Please select a file up to 10MB.');
            event.target.value = null; // limpa o valor do input
        } else {
            // processa o arquivo...
            setFile(event.target.files[0]);
        }
    };



    const sendMessage = async () => {
        console.log(messageData)
        if (!job) {
            const notData = {
                type: 'error',
                message: 'Provide the job description',
                title: 'wescout',
                timeOut: 1500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            return;
        }
        const message = `usuario: ${usuario.name}, vaga:${job}. observação: responder sempre com o mesmo padrao de json especificado da primeira vez`
        //const message = `usuario: Stephanie Nunez, vaga: Engenheiro Civíl`
        const createChatgptInput: any = {
            user: usuario._id,
            message,
            type: 'airesumefeedback',
            job: job
        }
        if (file) {
            console.log(file)
            createChatgptInput.pdf = file;
            //dataToSend.contador = (contador+1);
        }
        // dataToSend.id = dataToSend._id
        delete createChatgptInput.__typename
        console.log('createChatgptInput', createChatgptInput)
        if (typeof createChatgptInput.pdf == 'string') delete createChatgptInput.pdf
        setLoading(true)
        try {
            const userToken = await AiResumeFeedback({
                variables: {
                    createChatgptInput: createChatgptInput,

                },
                onCompleted: async({ airesumefeedback }) => {

                    console.log('airesumefeedback result== > ', airesumefeedback);
                    const notData = {
                        type: 'success',
                        message: 'Your resume has been successfully reviewed',
                        title: 'wescout',
                        timeOut: 1500,
                        callback: () => { },
                        priority: true,
                    }
                    Notifications(notData)
                    const res = airesumefeedback.response
                    setResult(res)
                    if (airesumefeedback._id) {
                        setActiveResultId(airesumefeedback._id)
                    }
                    //setChatgpt(airesumefeedback)
                    await getChatgptAsync(usuario)
                    setNewPdf(false)
                    setLoading(false)
                    setJob('')
                    setFile(null)
                    checkCredit(usuario)
                    const user: any = await whoami()
                    //console.log('whoami', user)
                    
                    if (user && user._id) {
                        const newUser: any = { ...user }
                        const profile = await getProfileByUserAsync(user._id)
                        if (profile && profile.pdf) {
                            newUser.pdf = profile.pdf
                        }
                        console.log('logged user ===> ', newUser)
                        setUser(newUser)
                    }
                }
            });
        } catch (error: any) {
            const notData = {
                type: 'error',
                message: error.message,
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            console.log("Erro ao atualizar usuário", error)
            setLoading(false)
        }
    }

    const handleNewPdf = () => {
        setNewPdf(true)
        setActiveResultId('')
    }

    const handleCloseResult = () => {
        setResult('')
        setActiveResultId('')
        getChatgptAsync(usuario)
    }



    const currentChatgptItem = chatgpt.find((item: any) => item._id === activeResultId);
    const isCurrentDefault = currentChatgptItem ? currentChatgptItem.isDefault : (chatgpt.length <= 1);

    return (
        <Container className={classes.container}>
            <div className='root'>
                <div className={classes.content}>
                    {/* <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button> */}
                    <Typography variant="h4" className={'title'}>
                        AI CV Analyse
                    </Typography>

                    {loading ? (
                        <Box sx={{ width: '100%' }}>
                            <LinearProgress />
                        </Box>
                    ) : null}
                    
                    <Box sx={{ width: '350px', border:'2px solid #31d841', borderRadius:50, padding: '5px', margin:'10px auto', marginTop:'20px' }}>
                        <Typography variant="h5"  >
                        Used credits: {usedCredits} of {totalCredits}
                    </Typography>
                    </Box>
                    


                    <Box sx={{ width: '100%', height: 100, }} style={{ alignSelf: 'center', paddingTop: 10, paddingBottom: 10, borderColor: 'green', borderWidth: 2 }}>
                        {newPdf ? <Stack>

                            <div className="file-upload">
                                {/* <img src={uploadImg} alt="upload" /> */}
                                {/* <Avatar sx={{ width: 108, height: 108 }} style={{margin:'0 auto'}} alt={usuario.name} src={image||usuario.avatar} /> */}
                                <UploadFile />
                                {file ? <div>file to upload: <span className='subtitle'>{file.name}</span> . </div> : null}
                                {/* <h3> {file?.name || "Choose a pdf file"}</h3> */}
                                <p>Maximum length 10mb</p>
                                {/* <input type="file" onChange={handleFileChange} /> */}
                                {
                                    !file?.name ? <label htmlFor="contained-button-file">
                                        <input
                                            accept="application/pdf"
                                            style={{ display: 'none' }}
                                            id="contained-button-file"
                                            type="file"
                                            onChange={handleFileChangePdf}
                                        />
                                        <Button variant="contained" component="span">
                                            Choose a pdf file
                                        </Button>
                                    </label> : (null
                                        /*  <Button variant="contained" component="span">
                                             Send your curriculum
                                         </Button> */
                                    )
                                }

                            </div>
                            <div>
                                <Typography component={'h2'} className='title'>
                                    Enter the information about the job you want to review with your resume.
                                </Typography>
                                <TextField
                                    style={{ maxWidth: "500px" }}
                                    label="Job description"
                                    value={job}
                                    onChange={(e) => setJob(e.target.value)}
                                /* InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <LinkIcon />
                                        </InputAdornment>
                                    ),
                                }} */

                                />
                            </div>
                            {
                                file ? <div style={{ maxWidth: '100%' }}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: '10px',
                                        margin: '16px auto',
                                        maxWidth: '560px',
                                        background: 'rgba(255,193,7,0.08)',
                                        border: '1.5px solid #FFC107',
                                        borderRadius: '10px',
                                        padding: '14px 16px',
                                        textAlign: 'left',
                                    }}>
                                        <input
                                            type="checkbox"
                                            id="cv-consent-checkbox"
                                            checked={cvConsent}
                                            onChange={(e) => setCvConsent(e.target.checked)}
                                            style={{ marginTop: '3px', accentColor: '#FFC107', width: '18px', height: '18px', flexShrink: 0, cursor: 'pointer' }}
                                        />
                                        <label htmlFor="cv-consent-checkbox" style={{ fontSize: '13px', color: '#b8860b', cursor: 'pointer', lineHeight: '1.5' }}>
                                            <strong>⚠️ CV Upload &amp; Data Responsibility Notice</strong><br />
                                            By uploading your CV or any document, you confirm that you have the legal right to do so and that it does not unlawfully include sensitive personal data of others. You accept full responsibility for the accuracy, legality, and use of the uploaded content.
                                        </label>
                                    </div>
                                    <Button disabled={loading || !cvConsent} className={classes.addButton} variant="contained" color="primary" onClick={() => sendMessage()}>
                                        Send
                                    </Button>
                                </div> : null

                            }

                        </Stack> :
                            <Button className={classes.addButton} variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => handleNewPdf()}>
                                New AI CV Analyse
                            </Button>
                        }
                        <Stack borderRadius={15} spacing={2} direction="column" alignItems={'center'} alignContent={'center'} divider={<Divider orientation="vertical" flexItem />}>
                            {
                                finalResult && !newPdf ? (
                                    <div id="chatbox" className='chatbox'>
                                        <Card style={{ width: '90%', maxWidth: '800px', margin: '0 auto', border: '1px solid #e0e0e0', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
                                            <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 16px', borderBottom: '1px solid #e0e0e0', backgroundColor: '#f5f5f5' }}>
                                                <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#333' }}>
                                                    CV Analysis Result
                                                </Typography>
                                                <Box style={{ display: 'flex', gap: '8px' }}>
                                                    {activeResultId && (
                                                        <Tooltip title={isCurrentDefault ? "Default CV" : "Set as Default"}>
                                                            <IconButton onClick={() => handleSetDefault(activeResultId)} disabled={loading} size="small" style={{ color: isCurrentDefault ? '#FFD700' : '#757575' }}>
                                                                {isCurrentDefault ? <StarIcon /> : <StarBorderIcon />}
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                    <Tooltip title="Copy to clipboard">
                                                        <IconButton onClick={() => {
                                                            const notData = {
                                                                type: 'success',
                                                                message: `Result copied to clipboard`,
                                                                title: 'wescout',
                                                                timeOut: 2500,
                                                                callback: () => { },
                                                                priority: true,
                                                            }
                                                            navigator.clipboard.writeText(result)
                                                            Notifications(notData)
                                                        }} size="small" style={{ color: '#757575' }}>
                                                            <FileCopy />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Close and refresh list">
                                                        <IconButton onClick={handleCloseResult} size="small" style={{ color: '#757575' }}>
                                                            <CancelIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </Box>
                                            <div dangerouslySetInnerHTML={{ __html: finalResult }} style={{ padding: '15px', fontFamily: 'Montserrat', textAlign: 'justify', color: 'black', height: '300px', overflowY: 'scroll' }}>
                                            </div>
                                        </Card>
                                    </div>
                                ) : null
                            }


                        </Stack>


                    </Box>
                    {
                        chatgpt.length ? (
                            <div className={classes.listContainer}>

                                {chatgpt.map((item: any, index: any) => (
                                    <Card sx={{ maxWidth: 345 }}>
                                        <CardHeader
                                            avatar={
                                                <Avatar sx={{ bgcolor: '#0df228' }} aria-label="recipe">
                                                    {item.user.name.substring(0, 2)}
                                                </Avatar>
                                            }
                                            action={
                                                <Tooltip title={item.isDefault ? "Default CV" : "Set as Default"}>
                                                    <IconButton onClick={() => handleSetDefault(item._id)} aria-label="set default">
                                                        {item.isDefault ? <StarIcon style={{color: '#FFD700'}} /> : <StarBorderIcon />}
                                                    </IconButton>
                                                </Tooltip>
                                            }
                                            title={item.user.name}
                                            subheader={clearData(item.createdAt)}
                                        />
                                        {item.job && (
                                            <Box style={{ padding: '8px 16px', backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
                                                <Typography variant="caption" style={{ fontWeight: 600, display: 'block', color: '#666' }}>
                                                    Job Interpretation:
                                                </Typography>
                                                <Typography variant="body2" style={{ fontWeight: 500, color: '#1976d2' }}>
                                                    {item.job}
                                                </Typography>
                                            </Box>
                                        )}
                                        {/* <CardMedia
                                            onClick={ ()=> setSelectedCompany(item) }
                                            component="img"
                                            height="194"
                                            image={ item.image ? serverConfig.dev.url + 'images/' + item.image : "https://robohash.org/"+item.name} 
                                            alt="Companie image"
                                            /> */}
                                        <CardContent>
                                            <Typography variant="body2" >
                                                Strength: {JSON.parse(item.response).grade}
                                            </Typography>
                                        </CardContent>
                                        <CardActions disableSpacing>
                                            <IconButton onClick={() => {
                                                const notData = {
                                                    type: 'success',
                                                    message: `Result copied to clipboard`,
                                                    title: 'wescout',
                                                    timeOut: 2500,
                                                    callback: () => { },
                                                    priority: true,
                                                }


                                                navigator.clipboard.writeText(item.response)
                                                Notifications(notData)
                                            }} aria-label="copy to clipboard">
                                                <FileCopy />
                                            </IconButton>
                                            <Button variant='contained' onClick={() => {

                                                handleExpandClick(item)
                                            }}>View your resume feedback</Button>


                                            {/* <ExpandMore
                                                expand={expanded == item._id ? true : false}
                                                onClick={() => { }}
                                                aria-expanded={expanded == item._id}
                                                aria-label="show more"
                                            >
                                                <ExpandMoreIcon />
                                            </ExpandMore> */}
                                        </CardActions>
                                        <Collapse in={expanded == item.name} timeout="auto" unmountOnExit>
                                            <CardContent>
                                                <Typography className='subtitle'>
                                                    {
                                                        finalResult ? (
                                                            <div id="chatbox" className='chatbox'>
                                                                <div dangerouslySetInnerHTML={{ __html: finalResult }} style={{ width: '100%', maxWidth: '800px', height: '350px', padding: '15px', fontFamily: 'Montserrat', textAlign: 'justify', color: 'white', margin: '0 auto', overflowY: 'scroll' }}>

                                                                </div>

                                                            </div>
                                                        ) : null
                                                    }
                                                </Typography>

                                            </CardContent>
                                        </Collapse>
                                    </Card>
                                )

                                )}


                            </div>
                        ) : null
                    }

                    <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button>
                </div>
            </div>

            <Dialog open={deleteConfirmationOpen} onClose={() => setDeleteConfirmationOpen(false)}>
                <DialogTitle>Confirm </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">Are you sure you want to delete?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteConfirmationOpen(false)}>Cancel</Button>
                    <Button onClick={handleDeleteConfirmation} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* AI Tool Notice Banner */}
            {noticeVisible && (
                <div style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    boxSizing: 'border-box',
                    background: 'linear-gradient(90deg, #1a1a2e 0%, #16213e 100%)',
                    borderTop: '2px solid #FFC107',
                    padding: '10px 56px 10px 24px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    zIndex: 1300,
                    boxShadow: '0 -2px 16px rgba(255,193,7,0.15)',
                }}>
                    <span style={{ fontSize: '18px', flexShrink: 0 }}>⚠️</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <span style={{ fontWeight: 700, color: '#FFC107', fontSize: '13px' }}>AI Tool Notice&nbsp;&nbsp;</span>
                        <span style={{ color: '#ccc', fontSize: '12px' }}>
                            AI-generated content may be inaccurate or incomplete and must be reviewed and verified before being relied upon.
                            By using this tool, you acknowledge that results are generated automatically and may contain errors,
                            and you accept full responsibility for validating and using the output.
                        </span>
                    </div>
                    <button
                        onClick={() => setNoticeVisible(false)}
                        title="Dismiss"
                        style={{
                            position: 'absolute',
                            right: '16px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            background: 'transparent',
                            border: '1px solid #FFC107',
                            borderRadius: '50%',
                            color: '#FFC107',
                            cursor: 'pointer',
                            width: '24px',
                            height: '24px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '14px',
                            lineHeight: 1,
                            flexShrink: 0,
                            padding: 0,
                        }}
                    >
                        ✕
                    </button>
                </div>
            )}

        </Container>
    );
};

const mapStateToProps = (state: any) => ({


    isLoadingUsuarios: state.usuarios.isLoadingUsuarios,
    isLoadingUsuariosByFilter: state.usuarios.isLoadingUsuariosByFilter,
    isLoadingCreateUsuario: state.usuarios.isLoadingCreateUsuario,
    empresas: state.empresas.empresas
});

const mapDispatchToProps = {
    setUser
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(AiResumeFeedback);
